var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import TrashSvg from './trash.icon.svg';
export const TrashIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: TrashSvg }));
_react_refresh_temp_1 = TrashIcon;
$RefreshReg$(_react_refresh_temp_1, "TrashIcon");
